// @ts-ignore
import { Component, OnInit } from '@angular/core';
import { SearchpostService} from '../../../services/searchpost.service';


// @ts-ignore
@Component({
  selector: 'app-header-inside',
  templateUrl: './header-inside.component.html',
  styleUrls: ['./header-inside.component.css']
})
export class HeaderInsideComponent implements OnInit {

  public searchPostResult;

  // tslint:disable-next-line:variable-name
  constructor( private _SearchpostService: SearchpostService) { }

  ngOnInit() {
  }
  getRoute(endpoint: string) {
    // const lang = localStorage.getItem('LOCAL_DEFAULT_LANGUAGE');
    return '/' + endpoint;
  }
  openSearch() {
    document.getElementById('myOverlay').style.display = 'block';
  }

  closeSearch() {
    document.getElementById('myOverlay').style.display = 'none';
  }

  searchPost(val) {
    this.searchPostResult = this._SearchpostService.searchPost(val.value);
  }
}
